import React from "react";
import Flex from "@irati/ui/src/Flex";
import { RadioOptionRow, RadioIconContainer, RadioIcon, RadioOptionText, MarginIconTooltip } from "./styled";
var toolTipRenderer = function (toolTipOptionRow) {
    var option = toolTipOptionRow.option, checked = toolTipOptionRow.checked;
    var label = option.label, tooltip = option.tooltip;
    return (React.createElement(RadioOptionRow, null,
        React.createElement(RadioIconContainer, null,
            React.createElement(RadioIcon, { checked: checked })),
        React.createElement(Flex, { justifyContent: "center", alignItems: "center" },
            React.createElement(RadioOptionText, { flush: true }, label),
            React.createElement(Flex, { margin: "0 0 0 5px" },
                React.createElement(MarginIconTooltip, null, tooltip)))));
};
export default toolTipRenderer;
